import api from './api';

const grievanceService = {
  createGrievance: async (payload) => {
    const response = await api.post('/grievances', payload);
    return response.data;
  },

  getMyGrievances: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.page)  query.append('page',  params.page);
    if (params.limit) query.append('limit', params.limit);
    const response = await api.get(`/grievances/my?${query.toString()}`);
    return response.data;
  },

  getAllGrievances: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.candidateId) query.append('candidateId', params.candidateId);
    if (params.status)      query.append('status',      params.status);
    if (params.page)        query.append('page',        params.page);
    if (params.limit)       query.append('limit',       params.limit);
    const response = await api.get(`/grievances?${query.toString()}`);
    return response.data;
  },

  getGrievanceById: async (id) => {
    const response = await api.get(`/grievances/${id}`);
    return response.data;
  },

  addFeedback: async (id, adminFeedback) => {
    const response = await api.put(`/grievances/${id}/feedback`, { adminFeedback });
    return response.data;
  },

  addReply: async (id, message) => {
    const response = await api.post(`/grievances/${id}/reply`, { message });
    return response.data;
  }
};

export default grievanceService;
